import { getErrorMessage } from '@us/web/shared/utils';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppInit } from '@us/web/shared/app';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import { PromotionsService } from '../services/promotions.service';
import { PromotionsActions } from './promotions.actions';

@Injectable()
export class PromotionsEffects {
    private readonly actions$ = inject(Actions);
    private readonly promotionsService = inject(PromotionsService);

    // loadPromotions$ = createEffect(() => {
    //     return this.actions$.pipe(
    //         ofType(AppInit, PromotionsActions.loadPromotions),
    //         concatMap(({ shopId }) => {
    //             return this.promotionsService.getPromotions({ with_details: 1 }).pipe(
    //                 map(promotions => PromotionsActions.loadPromotionsSuccess({ promotions })),
    //                 catchError(error => of(PromotionsActions.loadPromotionsFailure({ error: getErrorMessage(error) })))
    //             );
    //         })
    //     );
    // });
}
